import http from '../api/httpRequest.js'

export default {
	state: {
		webrtc: {},
		// 文件发送模式: 'agent' - 通过智能体发送, 'direct' - 直接发送
		fileSendMode: localStorage.getItem('fileSendMode') || 'direct'
	},
	mutations: {
		setConfig(state, config) {
			state.webrtc = config.webrtc;
		},
		setFileSendMode(state, mode) {
			state.fileSendMode = mode;
			localStorage.setItem('fileSendMode', mode);
		},
		clear(state) {
			state.webrtc = {};
		}
	},
	getters: {
		fileSendMode: state => state.fileSendMode
	},
	actions: {
		loadConfig(context) {
			return new Promise((resolve, reject) => {
				http({
					url: '/system/config',
					method: 'GET'
				}).then((config) => {
					context.commit("setConfig", config);
					resolve();
				}).catch((res) => {
					reject(res);
				});
			})
		}
	}

}